module.exports = __webpack_public_path__ + "img/2013-03-13 13.05.30.0b8039b5.jpg";